import React from "react";
import { Configure, Index } from "react-instantsearch";

export default function SearchSection({ indexName, indexId, config = {}, children }) {
    if (!indexName) return null;

    const defaultConfig = {
        hitsPerPage: 5,
        ...config
    };

    return (
        <Index indexName={indexName} indexId={indexId || indexName}>
            <Configure {...defaultConfig} />
            {children}
        </Index>
    );
}
